import { useState } from "react";
import { useForm } from "@mantine/form";
import {
  TextInput,
  PasswordInput,
  Text,
  Paper,
  Group,
  Button,
  Divider,
  Anchor,
  Stack,
  Container,
  Loader,
  Center,
  Alert,
} from "@mantine/core";
import { GoogleButton } from "../GoogleButton";
import { TwitterButton } from "../TwitterButton";
import { useStore } from "../store";
import { login } from "../api";
import { Link, useLocation } from "wouter";
import { IconInfoCircle } from "@tabler/icons-react";
import { socialLoginFactory } from "./socialLogin";
import { useEffect } from "react";

export default function LoginForm(props) {
  const [, setLocation] = useLocation();
  const [isFetching, setIsFetching] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const setAuthToken = useStore((state) => state.setAuthToken);
  const saveCurrentSession = useStore((state) => state.saveCurrentSession);
  const authToken = useStore((state) => state.authToken);

  const socialLogin = socialLoginFactory((event) => {
    saveCurrentSession();
    setAuthToken(event.data.token);
    setLocation("/home");
  });

  useEffect(() => {
    const isAddingAccount = new URLSearchParams(window.location.search).has(
      "addAccount"
    );
    if (authToken && !isAddingAccount) setLocation("/home");
  }, [authToken, setLocation]);

  const form = useForm({
    initialValues: {
      emailAddress: "",
      realm: "PS-TenantUser",
      password: "",
    },

    validate: {
      emailAddress: (val) => (/^\S+@\S+$/.test(val) ? null : "Invalid email"),
      // tenantSlug: (val) => (/^[a-z][a-z0-9_-]+$/.test(val) ? null : "Invalid slug"),
      password: (val) =>
        val.length < 8 ? "Password should include at least 8 characters" : null,
    },
  });


  return (
    <Container size="sm" mt="xl">
      {errorMessage && (
        <Alert
          variant="light"
          color="red"
          title="Login Failed"
          mb="lg"
          icon={<IconInfoCircle />}
        >
          {errorMessage}
        </Alert>
      )}

      <Paper radius="md" p="xl" withBorder {...props}>
        <Text size="lg" fw={500}>
          Login to PromptShuttle
        </Text>

        <Group grow mb="md" mt="md">
          <GoogleButton onClick={() => socialLogin("Google")} radius="xl">Google</GoogleButton>
          <TwitterButton disabled radius="xl">
            X / Twitter
          </TwitterButton>
        </Group>

        <Divider
          label="Or continue with email"
          labelPosition="center"
          my="lg"
        />

        <form
          onSubmit={form.onSubmit((values) => {
            setIsFetching(true);
            setErrorMessage(null);

            login({
              ...values,
              scope: "mandatory-field",
              realm: values.realm,
              username: values.emailAddress,
            })
              .then((data) => {
                saveCurrentSession();
                setAuthToken(data.access_token);
                setLocation("/home");
              })
              .catch((err) => {
                setIsFetching(false);
                if (err.cause == 400) {
                  setErrorMessage("Incorrect username or password");
                } else if (err.cause == 429) {
                  setErrorMessage(
                    "Too many login attempts. Please try again later."
                  );
                } else {
                  setErrorMessage("An unexpected error has occurred: " + err);
                }
              });
          })}
        >
          <Stack>
            {/* <TextInput
              label="Tenant slug"
              placeholder="jsmith"
              value={form.values.tenantSlug}
              onChange={(event) =>
                form.setFieldValue("tenantSlug", event.currentTarget.value)
              }
              radius="md"
            /> */}

            <TextInput
              required
              label="Email"
              placeholder="john@example.com"
              value={form.values.emailAddress}
              onChange={(event) =>
                form.setFieldValue("emailAddress", event.currentTarget.value)
              }
              error={form.errors.emailAddress && "Invalid email"}
              radius="md"
            />

            <PasswordInput
              required
              label="Password"
              placeholder="Your password"
              value={form.values.password}
              onChange={(event) =>
                form.setFieldValue("password", event.currentTarget.value)
              }
              error={form.errors.password}
              radius="md"
            />
          </Stack>

          <Group justify="space-between" mt="xl">
            <Stack>
              <Anchor
                c="dimmed"
                component={Link}
                href="/auth/register"
                size="xs"
              >
                Don't have an account? Register!
              </Anchor>
              <Anchor c="dimmed" component={Link} href="/auth/reset" size="xs">
                Forgot Password?
              </Anchor>
            </Stack>
            <Button type="submit" radius="xl">
              Login
            </Button>
          </Group>

          <Center>{isFetching && <Loader />}</Center>
        </form>
      </Paper>
    </Container>
  );
}
